(function () {
  'use strict';
  var touch = window.matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)');
  var dock, activeWrapper, mainObserver, navObserver, navResize, queued = false;
  var excluded = 'quick-order-list,.quick-order-list,quick-add-modal,bulk-modal,dialog,[role="dialog"]';

  function removeDock(disconnect) {
    if (activeWrapper) delete activeWrapper.dataset.asmPagingReady;
    activeWrapper = null;
    if (dock) dock.remove();
    dock = null;
    if (disconnect) {
      if (mainObserver) mainObserver.disconnect();
      if (navObserver) navObserver.disconnect();
      if (navResize) navResize.disconnect();
      mainObserver = navObserver = navResize = null;
    }
  }

  function urlFor(wrapper, page) {
    var links = Array.from(wrapper.querySelectorAll('.pagination a[href]'));
    var exact = links.find(function (link) { return link.textContent.trim() === String(page); });
    var source = exact || links[0];
    var url = new URL(source ? source.href : window.location.href, window.location.href);
    var current = new URL(window.location.href);
    var param = wrapper.dataset.pageParam || 'page';
    // Preserve storefront locale, filters/search, alternate view and theme preview.
    Array.from(new Set(current.searchParams.keys())).forEach(function (key) {
      if (key !== param && !url.searchParams.has(key)) {
        current.searchParams.getAll(key).forEach(function (value) { url.searchParams.append(key, value); });
      }
    });
    url.searchParams.set(param, String(page));
    if (wrapper.dataset.paginationView) url.searchParams.set('view', wrapper.dataset.paginationView);
    return url.pathname + url.search + url.hash;
  }

  function control(label, page, current, wrapper, arrow, disabled) {
    var element = document.createElement(disabled || page === current ? 'button' : 'a');
    element.className = 'asm-touch-page-control';
    element.setAttribute('aria-label', label);
    if (element.tagName === 'A') element.href = urlFor(wrapper, page);
    else element.type = 'button';
    if (disabled) element.disabled = true;
    if (!arrow && page === current) element.setAttribute('aria-current', 'page');
    if (arrow) {
      element.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (arrow === 'previous' ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6') + '"/></svg>';
    } else element.textContent = String(page);
    return element;
  }

  function buildNumbers(wrapper) {
    var current = Math.max(1, Number(wrapper.dataset.page) || 1);
    var total = Math.max(current, Number(wrapper.dataset.totalPages) || current);
    // Equal gutters keep the number row centered and clear of the cart on the right.
    var available = Math.max(32, Math.min(320, document.documentElement.clientWidth - 144));
    var count = Math.min(total, 7, Math.max(1, Math.floor((available + 4) / 34) - 2));
    if (count > 1 && count % 2 === 0) count -= 1;
    var first = Math.max(1, Math.min(current - Math.floor(count / 2), total - count + 1));
    var signature = [current, total, first, count, window.location.search].join('|');
    if (dock.dataset.signature === signature) return;
    dock.dataset.signature = signature;
    var navigation = document.createElement('nav');
    navigation.className = 'asm-touch-page-numbers';
    navigation.setAttribute('aria-label', 'Səhifələr — ' + current + ' / ' + total);
    navigation.append(control('Əvvəlki səhifə', current - 1, current, wrapper, 'previous', current === 1));
    for (var page = first; page < first + count; page += 1) {
      navigation.append(control('Səhifə ' + page + ' / ' + total, page, current, wrapper, '', false));
    }
    navigation.append(control('Növbəti səhifə', current + 1, current, wrapper, 'next', current === total));
    var old = dock.querySelector('.asm-touch-page-numbers');
    if (old) old.replaceWith(navigation);
    else dock.append(navigation);
  }

  function alignCart() {
    if (!dock) return;
    // The page row stays in document flow. Equal gutters preserve its horizontal alignment.
    dock.style.setProperty('--asm-pagination-width', document.documentElement.clientWidth + 'px');
    dock.style.setProperty('--asm-pagination-offset', -activeWrapper.getBoundingClientRect().left + 'px');
    var original = document.querySelector('.asm-touch-nav .asm-touch-floating-cart');
    var clone = dock.querySelector('.asm-touch-pagination-cart');
    var rect = original && original.getBoundingClientRect();
    var visible = rect && rect.width && rect.height && window.getComputedStyle(original).visibility !== 'hidden';
    if (visible) {
      if (clone) clone.remove();
    } else {
      if (original) {
        if (!clone) {
          clone = original.cloneNode(true);
          clone.classList.remove('asm-touch-floating-cart');
          clone.classList.add('asm-touch-pagination-cart');
          dock.append(clone);
        } else {
          var sourceBadge = original.querySelector('.cart-count-bubble');
          var targetBadge = clone.querySelector('.cart-count-bubble');
          if (sourceBadge && targetBadge) {
            if (targetBadge.innerHTML !== sourceBadge.innerHTML) targetBadge.innerHTML = sourceBadge.innerHTML;
            if (targetBadge.style.cssText !== sourceBadge.style.cssText) targetBadge.style.cssText = sourceBadge.style.cssText;
          }
        }
      }
    }
  }

  function ready() {
    queued = false;
    if (!touch.matches) { removeDock(true); return; }
    var main = document.querySelector('main#MainContent');
    if (!main) { removeDock(true); return; }
    if (!mainObserver) {
      mainObserver = new MutationObserver(schedule);
      mainObserver.observe(main, { childList: true, subtree: true });
      var nav = document.querySelector('.asm-touch-nav');
      if (nav) {
        navObserver = new MutationObserver(schedule);
        navObserver.observe(nav, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
        if (window.ResizeObserver) { navResize = new ResizeObserver(schedule); navResize.observe(nav); }
      }
    }
    var wrapper = Array.from(main.querySelectorAll('.pagination-wrapper[data-asm-pagination]')).find(function (candidate) {
      return !candidate.closest(excluded) && candidate.querySelector('.pagination');
    });
    if (!wrapper) { removeDock(false); return; }
    if (activeWrapper !== wrapper) {
      if (activeWrapper) delete activeWrapper.dataset.asmPagingReady;
      if (dock) delete dock.dataset.signature;
    }
    activeWrapper = wrapper;
    wrapper.dataset.asmPagingReady = 'true';
    if (!dock) {
      dock = document.createElement('div');
      dock.className = 'asm-touch-page-dock';
    }
    if (dock.parentElement !== wrapper) wrapper.append(dock);
    buildNumbers(wrapper);
    alignCart();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(ready);
  }
  touch.addEventListener('change', schedule);
  window.addEventListener('resize', function () { if (touch.matches || dock) schedule(); }, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
